// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import AuditResultModal from '../../state/audit-result-modal';
import AuditResultModalBody from './audit-result-modal-body';
import AuditResultModalHeader from './audit-result-modal-header';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

const AuditResultModalContainer = props =>
    <WarrantyMediumModal
        className='audit-result-modal-container'
        isOpen={props.auditResultModal.isVisible}
    >
        <AuditResultModalHeader
            onCloseButtonClick={props.onModalClose}
        />
        <AuditResultModalBody
            auditResult={props.auditResultModal.auditResult}
            onConfirmation={props.onModalClose}
        />
    </WarrantyMediumModal>;

AuditResultModalContainer.displayName = 'AuditResultModalContainer';
AuditResultModalContainer.propTypes = {
    auditResultModal: PropTypes.instanceOf(AuditResultModal).isRequired,
    onModalClose: PropTypes.func.isRequired
};

export default AuditResultModalContainer;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/components/audit-result-modal/index.js